<!--- NO MODAL ASSIGN PEOPLE-->
<ng-container *ngIf="nomodal">
  <app-loadconfirm *ngIf="showSpinner && !wizard" [text]="'projectassign.confirmassign'| trans " [icon]="'person_add'"></app-loadconfirm>
  <a data-toggle="collapse" href="#assignedCollapse">   
    <p>{{ 'projectassign.assignedpeople' | trans }} 
      <span class="material-icons">
    expand_more
    </span></p></a>
    <ng-container *ngIf="projectMembers && projectMembers.length > 0">
      <div class="row">
        <div class="col">
          <p class="mb-0">{{ 'projectassign.name' | trans }}</p>
        </div>
        <div class="col">
          <p class="text-center mb-0">{{ 'projectassign.role' | trans }}</p>
        </div>
        <div class="col">
          <p class="text-center mb-0">{{ 'projectassign.actions' | trans }}</p>
        </div>
      </div>
    </ng-container>
  <div *ngFor="let pmem of projectMembers; index as i" class="row collapse show mb-1" id="assignedCollapse{{i}}">
    <div class="card cursor-default" style="  
    margin-left: 10px;
    margin-right: 10px;
    padding-left: 10px;
    padding-right: 10px;
    border: #fafafa 1px solid;
    border-top: #fafafa 1px solid !important;
    background-color: #f2f2f2;
    width: 100%;
    border-radius: 5px;">
      <div class="row">
        <div class="col">
          <h6 class="card-person-text-read lh-35 mb-0 align-middle" id="name">{{pmem.fullname}}</h6>
        </div>
        <div class="col">
          <h6 class="card-person-text-read lh-35 mb-0 align-middle" id="name">{{pmem.projectrole}}</h6>
        </div>
        <div (click)="setDeleteMember(pmem)" data-toggle="modal" [attr.data-target]="'#userremovalconfirm'+project.projectId" class="col-1">
          <span class="material-icons rounded-circle w-35 h-35 lh-35 align-middle btn icon p-0 center cursor-pointer">
            delete
            </span>
        </div>
      </div>
      <div class="row">
      </div>
    </div>
  </div>
  <a data-toggle="collapse" href="#notassignedCollapse">   
    <p>{{ 'projectassign.unassignedpeople' | trans }} 
      <span class="material-icons">
    expand_more
    </span></p></a>
    <ng-container *ngIf="assignablePersons && assignablePersons.length > 0">
      <div class="row">
        <div class="col">
          <p class="mb-0">{{ 'projectassign.name' | trans }}</p>
        </div>
        <div class="col">
          <p class="text-center mb-0">{{ 'projectassign.title' | trans }}</p>
        </div>
        <div class="col">
          <p class="text-center mb-0">{{ 'projectassign.actions' | trans }}</p>
        </div>
      </div>
    </ng-container>
    <div *ngFor="let mem of assignablePersons; index as i" class="row collapse show" id="notassignedCollapse{{i}}">
      <div class="card ml-2 mr-2 pl-2 mb-2" style="
      border: #f2f2f2 2px solid;
      border-top: #f2f2f2 2px solid !important;
      background-color: #ffffff;
      width: 100%;
      border-radius: 5px;">
      <div class="">
        <div class="row">
          <div class="col-10">
            <h6 class="card-person-text cursor-default lh-40 align-middle mb-0" id="name">{{ mem.membername }}</h6>
          </div>
          <div class="col mr-2">
            <a *ngIf="!mem.assigned" class="cursor-pointer" matTooltip="{{ 'projectassign.assigntool' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
              <span id="assignmember{{i}}" (click)="mem.assigned = true" class="material-icons lh-40 align-middle card-person-text-read float-right text-align-center assign-icon">
                add
                </span></a>
                <a *ngIf="mem.assigned" class="cursor-pointer" matTooltip="{{ 'projectassign.assignproject' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
                  <span (click)="mem.assigned = false; removeSelection(mem.personId)" class="material-icons lh-40 align-middle card-person-text-read float-right  text-align-center assigned-icon">
                    done
                    </span>
                    </a>
          </div>
          </div>
          <div *ngIf="mem.assigned" class="row mb-2">
            <div class="col pr-0">
              <div class="row mr-3">
                <div *ngIf="project.templateId" class="col-3 pr-0">
                  <label class="modal-title lh-35 align-middle f-13" id="userid" for="userroledefine">{{ 'projectassign.define' | trans }}</label>
                </div>
                <div *ngIf="project.templateId == null || !project.templateId" class="col-2 pr-0">
                  <label class="modal-title lh-35 align-middle f-13" id="userid" for="userroledefine">{{ 'projectassign.define' | trans }}</label>
                </div>
                <div *ngIf="project.templateId" class="col-9 pl-0">
                  <input [disabled]="mem.projectTemplateRole && mem.projectTemplateRole != 'none'" class="form-control" style="font-size: 13px; font-weight: 100;"   type="text" class="form-control mb-0" id="userroledefine" 
                  placeholder="{{ 'projectassign.defineplace' | trans }}" [(ngModel)]="mem.projectrole" required>
                </div>
                <div *ngIf="project.templateId == null || !project.templateId" class="col-10 pl-0">
                  <input [disabled]="mem.projectTemplateRole && mem.projectTemplateRole != 'none'" class="form-control" style="font-size: 13px; font-weight: 100;"   type="text" class="form-control mb-0" id="userroledefine" 
                  placeholder="{{ 'projectassign.defineplace' | trans }}" [(ngModel)]="mem.projectrole" required>
                </div>
                <small id="userroledefine" class="form-text text-muted pl-3 f-10 pr-3">
                  {{ 'projectassign.assignrolehelper' | trans }}
                </small>
              </div>
            </div>
            <div *ngIf="projectMembers.length == 0 && project.templateId && !showroles" class="col pr-4" style="border-left-width: 1px!important; border-left: solid #c2c2c2;">
              <div class="row">
                <div *ngIf="projectMembers.length == 0 && project.templateId" class="col-3 pr-0">
                  <label class="modal-title lh-35 align-middle f-13" id="select" for="exampleFormControlSelect1">{{ 'projectassign.template' | trans }}</label>
                  <!-- <label class="modal-title" *ngIf="mem.assigned == true" id="userid" for="formGroupExampleInput">{{mem.membername}}</label> -->
                </div>
                <div *ngIf="projectMembers.length == 0 && project.templateId "  class="col-9 pl-0 pr-3">
                  <app-assigntemplateroles [update]="update" [disableAssign]="mem.projectrole != undefined && mem.projectrole != ''" (roleToAssignEE)="assignRole($event,mem.personId) " (rolesEE)="setRoles($event)" [project]="project" [personId]="mem.personId"></app-assigntemplateroles>
                </div>
                <small id="userroledefine" class="form-text text-muted pl-3 f-10 pr-3">
                  {{ 'projectassign.assigntemplaterolehelper' | trans }}
                </small>
              </div>
            </div>
          </div>
        
      </div>

      </div>

    </div>
 

    <div *ngIf="errorMessage!=null" class="alert alert-danger ml-0 mr-0">
      <h6 class="error-msg mb-0">{{ errorMessage | trans }}</h6>
  </div>
    <div class="row mb-2 mt-3">
      <div class="col">
        <button type="button" (click)="assignToProject(true)" class="btn float-right w-100"><h6 class="btn-text">{{ 'projectassign.assign' | trans }}</h6></button>
    </div>
    <!----<div class="col">
      <button type="button" (click)="assignToProject(true)" class="btn-save float-right"><h6 class="btn-save-text">{{ 'projectassign.assignandtag' | trans }}</h6></button>
    </div>--->
    </div>
</ng-container>


<!-- Modal ASSIGN PEOPLE -->
<!-- <div class="modal fade" id="assignProject" tabindex="-1" role="dialog" aria-labelledby="assignPeopleTitle" >
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ 'projectassign.assigntool' | trans }}</h5>
        <button (click)="closeModal()" type="button" class="close">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-loadconfirm *ngIf="showSpinner" [text]="'projectassign.confirmassign'| trans " [icon]="'person_add'"></app-loadconfirm>
        <ng-container>
          <div class="card bg-secondary ml-0 mr-0 p-2 mb-3">
            <div class="row">
              <div class="col-auto">
                <span class="material-icons pl-2">
                  help_outline
                  </span>
              </div>
              <div *ngIf="!project.templateId" class="col-10">
                  <p class="mb-0">{{ 'projectassign.assignhelpertext' | trans }} </p>
              </div>
              <div *ngIf="project.templateId" class="col-10">
                <p class="mb-0">{{ 'projectassign.assignhelpertexttemplate' | trans }} </p>
            </div>
            </div>
          </div>
        </ng-container>

        <a *ngIf="projectMembers.length > 0" data-toggle="collapse" href="#assignedCollapse">   
          <p>{{ 'projectassign.assignedpeople' | trans }}  
            <span class="material-icons">
          expand_more
          </span></p></a>

          <ng-container *ngIf="projectMembers.length > 0">
            <div class="row">
              <div class="col">
                <p class="mb-0">{{ 'projectassign.name' | trans }}</p>
              </div>
              <div class="col">
                <p class="text-center mb-0">{{ 'projectassign.role' | trans }}</p>
              </div>
              <div class="col">
                <p class="text-center mb-0">{{ 'projectassign.actions' | trans }}</p>
              </div>
            </div>
          </ng-container>
        <div *ngFor="let pmem of projectMembers" class="row collapse show mb-1" id="assignedCollapse">
          <div class="card cursor-default" style="  
          margin-left: 10px;
          margin-right: 10px;
          padding-left: 10px;
          padding-right: 10px;
          border: #fafafa 1px solid;
          border-top: #fafafa 1px solid !important;
          background-color: #f2f2f2;
          width: 100%;
          border-radius: 5px;">
            <div class="row">
              <div class="col">
                <h6 class="card-person-text-read lh-35 mb-0 align-middle" id="name">{{pmem.fullname}}</h6>
              </div>
              <div class="col">
                <h6 class="card-person-text-read lh-35 mb-0 align-middle" id="name">{{pmem.projectrole}}</h6>
              </div>
              <div (click)="setDeleteMember(pmem)" data-toggle="modal" [attr.data-target]="'#userremovalconfirm'+project.projectId" class="col-1">
                <span class="material-icons rounded-circle w-35 h-35 lh-35 align-middle btn icon p-0 center cursor-pointer">
                  delete
                  </span>
              </div>
            </div>
            <div class="row">
            </div>
          </div>
        </div>
        <a data-toggle="collapse" href="#notassignedCollapse">   
          <p>{{ 'projectassign.unassignedpeople' | trans }}  
            <span class="material-icons">
          expand_more
          </span></p></a>
          <ng-container>
            <div class="row">
              <div class="col">
                <p class="mb-0">{{ 'projectassign.name' | trans }}</p>
              </div>
              <div class="col">
                <p class="text-center mb-0">{{ 'projectassign.title' | trans }}</p>
              </div>
              <div class="col">
                <p class="text-center mb-0">{{ 'projectassign.actions' | trans }}</p>
              </div>
            </div>
          </ng-container>

        <div *ngFor="let mem of assignablePersons" class="row collapse show" id="notassignedCollapse">
          <div class="card ml-2 mr-2 pl-2 mb-2" style="
          border: #f2f2f2 2px solid;
          border-top: #f2f2f2 2px solid !important;
          background-color: #ffffff;
          width: 100%;
          border-radius: 5px;">
          <div class="">
            <div class="row">
              <div class="col-10">
                <h6 class="card-person-text cursor-default lh-40 align-middle mb-0" id="name">{{ mem.membername }}</h6>
              </div>
              <div class="col mr-2">
                <a *ngIf="!mem.assigned" class="cursor-pointer" matTooltip="{{ 'projectassign.assigntool' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
                  <span (click)="mem.assigned = true" class="material-icons lh-40 align-middle card-person-text-read float-right text-align-center assign-icon">
                    add
                    </span></a>
                    <a *ngIf="mem.assigned" class="cursor-pointer" matTooltip="{{ 'projectassign.assigntool' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
                      <span (click)="mem.assigned = false; removeSelection(mem.personId)" class="material-icons lh-40 align-middle card-person-text-read float-right text-align-center assigned-icon">
                        done
                        </span>
                        </a>
              </div>
              </div>

              <div *ngIf="mem.assigned" class="row mb-2">
                <div class="col pl-3 pr-3">
                  <div class="row">
                    <div class="col-3 pr-0">
                      <label class="modal-title lh-35 align-middle f-13" id="userid" for="formGroupExampleInput">{{ 'projectassign.define' | trans }}</label>
                    </div>
                    <div class="col-8 pl-0">
                      <input [disabled]="mem.projectTemplateRole && mem.projectTemplateRole != 'none'" class="form-control" style="font-size: 13px; font-weight: 100;"   type="text" class="form-control mb-0" id="formGroupExampleInput" 
                      placeholder="{{ 'projectassign.defineplace' | trans }}" [(ngModel)]="mem.projectrole" required>
                    </div>
                    <small id="userroledefine" class="form-text text-muted pl-3 f-10">
                      {{ 'projectassign.assignrolehelper' | trans }}
                    </small>
                    </div>
                </div>
                <div *ngIf="this.projectMembers.length == 0 && project.templateId"  class="col pl-3 pr-3" >
                  <div class="row">
                    <div class="col-3 pr-0">
                      <label class="modal-title lh-35 align-middle f-13" id="select" for="exampleFormControlSelect1">{{ 'projectassign.template' | trans }}</label>
                    </div>
                    <div *ngIf="this.projectMembers.length == 0 && project.templateId "  class="col-8 pl-0">
                      <app-assigntemplateroles [update]="update" [disableAssign]="mem.projectrole != undefined && mem.projectrole != '' || nomodal" (roleToAssignEE)="assignRole($event,mem.personId)"  (rolesEE)="setRoles($event)"  [project]="assignProject" [personId]="mem.personId"></app-assigntemplateroles>
                    </div>
                    <small id="userroledefine" class="form-text text-muted pl-3 pr-3 f-10">
                      {{ 'projectassign.assigntemplaterolehelper' | trans }}
                    </small>
                  </div>
                </div>
               
            </div>

          </div>

          </div>

        </div>
        <div *ngIf="errorMessage!=null" class="alert alert-danger ml-0 mr-0">
          <h6 class="error-msg mb-0">{{ errorMessage | trans }}</h6>
      </div>
        <div class="row">
          <div class="col">
            <button type="button" class="btn-close" data-dismiss="modal"><h6 class="btn-save-text">{{ 'projectassign.close' | trans }}</h6></button>
          </div>
          <div class="col">
            <button type="button" (click)="assignToProject()" class="btn-save float-right"><h6 class="btn-save-text">{{ 'projectassign.assignproject' | trans }}</h6></button>
        </div>
        </div>


      </div>
    
    </div>
  </div>
</div> -->


  <!-- Modal USER ROLE EDIT -->
  <!-- <div class="modal fade" id="modaleditrole{{project.projectId}}" tabindex="-1" role="dialog" >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">{{ 'projectassign.edituserrole' | trans }}</h5>
          <button #rolemodalclose type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span >&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <div class="form-group">
                <input type="email" class="form-control" aria-describedby="userrolehelp" placeholder="{{ 'projectassign.edituserroleplace' | trans }}" [(ngModel)]="modalPerson.projectrole">
                <small id="userrolehelp" class="form-text text-muted">{{ 'projectassign.edituserrolehelp' | trans }}</small>
              </div>
        </div>
        <div class="modal-footer">
            <div class="col">
                <button type="button" class="btn-close float-left" data-dismiss="modal"><p class="btn-save-text">{{ 'projectassign.close' | trans }}</p></button>
            </div>
            <div class="col">
                <button (click)="saveRole()" type="button" class="btn-save float-right"><p class="btn-save-text">{{ 'projectassign.savechanges' | trans }}</p></button>
            </div>
        </div>
      </div>
    </div>
  </div> -->

    <!-- Modal USER REMOVEVAL CONFIRM -->
    <div id="userremovalconfirm{{project.projectId}}" class="modal fade" tabindex="-1" role="dialog" >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">{{ 'projectassign.confirmuserremoveval' | trans }}</h5>
              <button #deletemodalclose type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span >&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <p class="font-weight-light text-center">{{ 'projectassign.confirmuserremovevalcheck' | trans }}</p>
                <p class="mt-2 text-center text-muted">{{ memberToDelete.fullname }}</p>
            </div>
            <div class="modal-footer">
                <div class="col">
                    <button type="button" class="btn-close" data-dismiss="modal"><p class="btn-save-text">{{ 'projectassign.cancel' | trans }}</p></button>
                </div>
                <div class="col">
                    <button (click)="deleteMember()" type="button" class="btn-save"><p class="btn-save-text">{{ 'projectassign.removeuser' | trans }}</p></button>
                </div>
            </div>
          </div>
        </div>
      </div>